module.exports = __webpack_public_path__ + "img/title_WechatWork.f3a96aed.svg";